/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/**
 * Provides the behavior and accessibility implementation for a dialog component.
 * A dialog is an overlay shown above other content in an application.
 */

import { useDialog as useDialogAria } from '@react-aria/dialog';
import { mapDomPropsToRN } from '@react-native-aria/utils';
export function useDialog(props, ref) {
  const params = useDialogAria(props, ref);
  params.dialogProps = params.dialogProps;
  params.dialogProps = mapDomPropsToRN(params.dialogProps);
  return params;
}
//# sourceMappingURL=useDialog.web.js.map